module.exports = __webpack_public_path__ + "static/media/мастер-класс-по-макияжу.147a3293.jpg";